import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardActions, CardContent, Typography } from "@material-ui/core";
import NewCourse from "./NewCourse.js";
import moment from "moment";

const useStyles = makeStyles({
    root: {
        minWidth: 275,
        minHeight: "100%",
        display: "flex",
        flexDirection: "column"
    },
    title: {
        fontSize: 14
    },
    pos: {
        marginBottom: 12
    },
    desc: { maxHeight: 100, overflowY: "hidden" }
});

export default props => {
    const classes = useStyles();

    return (
        <Card className={classes.root}>
            <CardContent style={{ flex: 1 }}>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                    {moment(new Date(Number((props.course.dates[0] || {}).from))).format("DD/MM/YYYY")} -{" "}
                    {moment(new Date(Number((props.course.dates[props.course.dates.length - 1] || {}).to))).format(
                        "DD/MM/YYYY"
                    )}
                </Typography>
                <Typography variant="h5" component="h2">
                    {props.course.title}
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                    Deltagere: {props.course.limit}
                </Typography>
                <Typography
                    className={classes.desc}
                    variant="body2"
                    component="p"
                    dangerouslySetInnerHTML={{ __html: props.course.description }}></Typography>
            </CardContent>
            <CardActions>
                <NewCourse new={false} course={props.course} getCourses={props.getCourses} />
            </CardActions>
        </Card>
    );
};
